export default __webpack_public_path__ + "static/media/role-holder-shaded.2f865b3e.png";